<ng-container *ngIf="antwoordResultaat && antwoordResultaat.resultaat">
    <div data-hj-suppress class="ols-summary-answer {{toggleClass}}" *ngIf="setHeight()"
      [innerHTML]="geefAntwoord()"></div>
    <span (click)="toggleAnswer()" class="toggle-button {{buttonClass}}" [innerHTML]="toggleTekst"></span>
</ng-container>